export type GoogleIdentityClaims = {
  sub?: string;
  email: string;
  name?: string;
  given_name?: string;
  picture?: string;
  hd?: string;
  exp: number;
};

export function parseWorkspaceDomains(configured?: string): string[] {
  const domains = configured
    ?.split(",")
    .map((domain) => domain.trim().toLowerCase())
    .filter(Boolean);
  return domains?.length ? [...new Set(domains)] : ["recoequip.com"];
}

export function decodeCredential(token: string): GoogleIdentityClaims {
  const body = token.split(".")[1];
  if (!body) throw new Error("Google returned an invalid identity token");
  const normalized = body.replaceAll("-", "+").replaceAll("_", "/");
  const bytes = Uint8Array.from(atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=")), character => character.charCodeAt(0));
  return JSON.parse(new TextDecoder("utf-8", { fatal: true }).decode(bytes)) as GoogleIdentityClaims;
}

export function validateWorkspaceIdentity(
  identity: GoogleIdentityClaims,
  allowedDomains: readonly string[],
  now = Date.now(),
): GoogleIdentityClaims {
  if (!identity.hd || !allowedDomains.includes(identity.hd.trim().toLowerCase())) {
    throw new Error("Use an approved RECO Google Workspace account");
  }
  if (!Number.isFinite(identity.exp) || identity.exp * 1000 <= now) throw new Error("Your Google sign-in has expired");
  return identity;
}
